module.exports = __webpack_public_path__ + "img/none.2d47174a.png";